"use strict";
/* eslint-disable @typescript-eslint/no-var-requires */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserAgent = exports.isBrowser = void 0;
function isBrowser() {
    return (typeof window !== 'undefined' && typeof window.document !== 'undefined');
}
exports.isBrowser = isBrowser;
let memoizedUserAgent = null;
function getUserAgent() {
    if (memoizedUserAgent !== null) {
        return memoizedUserAgent;
    }
    const packageInfo = require('../package.json');
    memoizedUserAgent = `${packageInfo.name}/${packageInfo.version}`;
    return memoizedUserAgent;
}
exports.getUserAgent = getUserAgent;
//# sourceMappingURL=runtime.js.map